import { __makeTemplateObject } from "tslib";
import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
var Holder = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var PopoverContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  white-space: normal;\n  width: 280px;\n  max-width: 80vw;\n  padding: 12px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 0 32px rgba(0, 0, 0, 0.32);\n  transform: ", ";\n  transition: all 0.2s ease;\n  z-index: 100;\n\n"], ["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  white-space: normal;\n  width: 280px;\n  max-width: 80vw;\n  padding: 12px;\n  background: #f9f9f9;\n  border-radius: 8px;\n  box-shadow: 0 0 32px rgba(0, 0, 0, 0.32);\n  transform: ", ";\n  transition: all 0.2s ease;\n  z-index: 100;\n\n"])), function (_a) {
    var translateX = _a.translateX;
    return "translate(".concat(translateX, "px)");
});
var Popup = function (_a) {
    var ButtonNode = _a.button, visible = _a.visible, onClickedOutside = _a.onClickedOutside, children = _a.children, insidePopup = _a.insidePopup, translateX = _a.translateX;
    var ref = useRef(null);
    useEffect(function () {
        function handleClickOutside(event) {
            if (onClickedOutside &&
                visible &&
                ref.current &&
                !ref.current.contains(event.target)) {
                onClickedOutside();
            }
        }
        document.addEventListener('click', handleClickOutside);
        return function () {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref, visible]);
    return (React.createElement(Holder, { ref: ref },
        ButtonNode,
        visible ? (React.createElement(PopoverContainer, { translateX: translateX || 0, visible: visible },
            insidePopup,
            children)) : null));
};
export default Popup;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Popup.js.map